<template>
  <v-container fluid grid-list-xs>
    <v-layout row wrap mb-2 class="grey lighten-4">
      <v-flex>
        <h2>
          <router-link to="/billings">Billings</router-link>
          <span class="grey--text">&gt;</span>
          {{ billing.card_name }} <span class="grey--text">(</span>{{ billing.id }}<span class="grey--text">)</span>
        </h2>
      </v-flex>
    </v-layout>

    <BillingCard :billing="billing"></BillingCard>

    <v-divider class="my-2"></v-divider>

    <h3>Tokens:</h3>

    <v-layout row wrap>
      <v-flex xs12 sm6 pa-2 v-for="token in billing.tokens" :key="token.id">
        <PaymentTokenCard :billing="billing" :paymentToken="token" showActions></PaymentTokenCard>
      </v-flex>
    </v-layout>
    <!--
    <v-divider class="primary"></v-divider>
    <v-expansion-panel
      v-model="panel"
      expand
      multiple
      class="elevation-0"
    >
      <v-expansion-panel-content>
        <div slot="header" class="title font-weight-medium">
          Related Billings
        </div>
          <Billings ref="terminals" :billingId="billing.id" v-if="billing.id"></Billings>
      </v-expansion-panel-content>
    </v-expansion-panel>
    -->
  </v-container>
</template>

<script>
import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

import BillingCard from '@/components/terminal/components/BillingCard'
import PaymentTokenCard from '@/components/terminal/components/PaymentTokenCard'

export default {
  components: {BillingCard, PaymentTokenCard},
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      billing: {},
      panel: []
    }
  },

  mounted () {
    this.load()
  },

  methods: {
    async load () {
      try {
        Bus.$emit('openWaitModal')

        if (!this.$route.params.id) {
          throw new Error('Invalid billing')
        }

        let data = await this.api({url: `/billings/${this.$route.params.id}`})
        this.billing = data.data.billing
      } catch (error) {
        Bus.$emit('openModal', {status: 'error', message: error})
      } finally {
        Bus.$emit('closeWaitModal')
      }
    },

    async setStatus (isEnabled = 1) {
      let subPath = 'enable'
      if (isEnabled === 0) {
        subPath = 'disable'
      }

      if (confirm(`Are you sure you would like to ${subPath} this token?`)) {
        try {
          Bus.$emit('openWaitModal')

          await this.api({
            method: 'put',
            url: `/tokens/${this.user.id}/${subPath}`
          })

          // reload user or switch value?
          let data = await this.api({url: `/tokens/${this.$route.params.id}`})
          this.user = data.data.user
        } catch (error) {
          console.log('Error updating status')
          console.log(error)
        } finally {
          Bus.$emit('closeWaitModal')
        }
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/billings/Billing.vue